import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    menuIsOpen: false,
    percentageIntense:{
      one:0,
      two:0,
      three:0
    }
  },
  mutations: {

  },
  actions: {}
});

